// extracted by mini-css-extract-plugin
export default {"input":"input-control_input__FpHx1"};